import styled from 'styled-components';
import { ActionButton } from './ui';
import { useRef, useState } from 'react';
import { useVehicleListContext } from '../../context';
import { FilterForm } from '../Filters/FilterForm';
import { ButtonBase, Popover } from '@material-ui/core';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import FilterIcon from 'components/Icons/classic_filter.svg';
import { useHeaderContext } from './context';
import ActiveFilterIcon from 'components/Icons/classic_filter_blue.svg';
import { useOnClickOutside } from 'usehooks-ts';

const NumberOfFilters = styled.div`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 100%;
  right: -11px;
  top: -11px;
  background: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

export const FilterButton = () => {
  const { isMobile } = useDeviceInfo();
  if (isMobile) return <MobileFilterButton />;
  return <DesktopFilterButton />;
};

const DesktopFilterButton = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const { getFilters } = useVehicleListContext();
  const filters = getFilters();
  const filtersCount = Object.keys(filters).filter(
    key => key !== 'order_by' && !key.endsWith('_operator') && !!filters[key]
  ).length;

  const ref = useRef<HTMLDivElement>(null);

  const handleOpenPopover = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const onNewAdditionalFilter = () => {
    setTimeout(() => ref.current?.scrollTo(0, ref.current.scrollHeight), 0);
  };

  return (
    <>
      <ActionButton onClick={handleOpenPopover}>
        <span>Filter</span>
        {filtersCount > 0 && <NumberOfFilters>{filtersCount}</NumberOfFilters>}
      </ActionButton>

      <Popover
        id="vehicle-list-filter-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        marginThreshold={130}
      >
        <div ref={ref} style={{ maxHeight: '540px', overflowY: 'auto', paddingBottom: '12px' }}>
          <FilterForm onNewAdditionalFilter={onNewAdditionalFilter} />
        </div>
      </Popover>
    </>
  );
};

const MobileFilterWrapper = styled.div`
  flex-grow: 1;
  margin-top: -24px;
  padding-bottom: 24px;
  margin-right: -12px;
  max-height: calc(100vh - 72px - 110px);
  border-bottom-left-radius: 6px;
  overflow-y: auto;
  border-bottom-right-radius: 6px;
`;

const MobileFilterButton = () => {
  const { mobileFiltersOpened, toggleMobileFilters } = useHeaderContext();

  const ref = useRef<HTMLDivElement>(null);

  const onNewAdditionalFilter = () => {
    setTimeout(() => ref.current?.scrollTo(0, ref.current.scrollHeight), 0);
  };

  useOnClickOutside(ref, e => {
    const modal = document.querySelector('div[id^="menu-"]');
    if (modal && e.target && modal.contains(e.target as Node)) {
      return;
    }

    if (mobileFiltersOpened) {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileFilters();
    }
  });

  return (
    <>
      <ButtonBase onClick={toggleMobileFilters}>
        {mobileFiltersOpened ? <ActiveFilterIcon /> : <FilterIcon />}
      </ButtonBase>

      {mobileFiltersOpened && (
        <MobileFilterWrapper ref={ref}>
          <FilterForm onNewAdditionalFilter={onNewAdditionalFilter} />
        </MobileFilterWrapper>
      )}
    </>
  );
};
